import { assertNever, Blackjack, EventQueue } from 'game-logic';
import { BetController } from './bet-controller';
import { BlackjackGameRunner } from '../../model/blackjack-game-runner';
import { InterfaceEvents } from '../services/game-services';

export class InterfaceController {
  public get currentBetChips(): ReadonlyArray<Blackjack.ChipDenomination> {
    return this.betController.currentBetChips;
  }

  private readonly betController: BetController;

  constructor(
    private blackjackGameRunner: BlackjackGameRunner,
    interfaceEventQueue: EventQueue<InterfaceEvents>,
    gameListener: Blackjack.BlackjackListener,
  ) {
    this.betController = new BetController(blackjackGameRunner, interfaceEventQueue, gameListener);
  }

  public increaseCurrentBet(chip: Blackjack.ChipDenomination): void {
    this.betController.increaseCurrentBet(chip);
  }

  public clearCurrentBet(): void {
    this.betController.clearCurrentBet();
  }

  public uiButtonTapped(uiButton: Blackjack.UiButtonType): void {
    switch (uiButton) {
      case Blackjack.UiButtonType.Clear:
        this.betController.clearCurrentBet();
        break;
      case Blackjack.UiButtonType.AllIn:
        this.betController.betAllIn();
        break;
      case Blackjack.UiButtonType.Deal:
        this.blackjackGameRunner.currentGame?.dealDeck(this.betController.totalBetAmount);
        break;
      case Blackjack.UiButtonType.Stand:
        this.blackjackGameRunner.currentGame?.playerStandDeck();
        break;
      case Blackjack.UiButtonType.Double:
        this.blackjackGameRunner.currentGame?.playerDoubleDeck();
        break;
      case Blackjack.UiButtonType.Split:
        this.blackjackGameRunner.currentGame?.playerSplitDeck();
        break;
      case Blackjack.UiButtonType.Hit:
        this.blackjackGameRunner.currentGame?.playerHitDeck();
        break;
      case Blackjack.UiButtonType.Continue:
        this.blackjackGameRunner.currentGame?.continueRound(false);
        break;
      default:
        assertNever(uiButton, `Unknown ui button type`);
    }
  }
}
